// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"f63882f2","769":"7cd4a69b"}[chunkId] + ".chunk.js";
};